import {Component, HostListener, ViewChild, ViewContainerRef} from '@angular/core';
import {User} from "../../../models/User";
import {menu, MenuItem} from "../../../core/const/menu";
import {AsideService, AsideState} from "../../../core/states/aside-service.service";
import {AuthStateService} from "../../../core/states/auth-state.service";
import {AuthService} from "../../../services/auth.service";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {AsideNavItemComponent} from "./aside-nav-item/aside-nav-item.component";
import {RouterLink} from "@angular/router";
import {slideInOutAnimation} from "../../../core/const/animations";
import { BreadcrumbService } from '../../../core/services/breadcrumb/breadcrumb.service';
import { Breadcrumb } from '../../../models/Breadcrumb';

@Component({
  selector: 'app-aside-nav',
  standalone: true,
  imports: [
    NgClass,
    AsideNavItemComponent,
    NgIf,
    RouterLink,
    NgForOf
  ],
  templateUrl: './aside-nav.component.html',
  styleUrl: './aside-nav.component.css',
  animations: [
    slideInOutAnimation
  ]
})
export class AsideNavComponent {
  @ViewChild('template', { static: true }) template: any;
  isCollapsed = false;
  asideState!: AsideState
  menuState:string = 'out';
  mobileMenuOpen: boolean = false;
  menuItems = menu;
  user: User|null = null;

  permissions: string[] = [];

  breadcrumbs: Breadcrumb | null = null;

  isDropdownOpen = false;

  // Selector de sucursal (operadoras)
  isOperator = false;
  offices: any[] = [];
  activeOffice: any = null;
  officeDropdownOpen = false;
  switchingOffice = false;

  constructor(
    private viewContainerRef: ViewContainerRef,
    public asideService: AsideService,
    public authStateService: AuthStateService,
    private authService: AuthService,
    private breadcrumbService: BreadcrumbService,
  ) {
    this.asideService.asideState$.subscribe({
      next: (data: AsideState) => {
        this.asideState = data;
      }
    })
    this.asideService.movileMenuOpenState$.subscribe({
      next: (open: boolean) => {
        this.mobileMenuOpen = open;
        this.menuState = open ? 'in' : 'out';
      }
    })

    this.breadcrumbService.breadcrumb.subscribe(data => {
      this.breadcrumbs = data;
    })

    this.authStateService.currentUser.subscribe(data => {
      this.user = data;
      // Permisos del usuario para filtrar el menú por rol.
      this.permissions = data?.permissions ?? [];
      // Sucursal activa (operadoras)
      this.isOperator = (data?.roles?.includes('operator')) ||
        (Array.isArray(data?.profile?.roles) && data!.profile.roles.some((r: any) => r.name === 'operator')) || false;
      this.offices = data?.offices ?? [];
      this.activeOffice = data?.active_office ?? null;
    });
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }


    // Escuchar clics en el documento
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
      const dropdownElement = document.querySelector('.relative'); // Selecciona el contenedor del menú
      const targetElement = event.target as HTMLElement;
  
      // Verifica si el clic fue fuera del menú
      if (dropdownElement && !dropdownElement.contains(targetElement)) {
        this.isDropdownOpen = false; // Cierra el menú
      }

      // Cerrar el selector de sucursal al hacer clic fuera.
      if (this.officeDropdownOpen && !targetElement.closest('.office-switcher')) {
        this.officeDropdownOpen = false;
      }
    }

    // Alternar el menú desplegable
    toggleDropdown(event: MouseEvent): void {
      event.stopPropagation(); // Evita que el clic se propague al documento
      this.isDropdownOpen = !this.isDropdownOpen;
    }

  toggleOfficeDropdown(event: MouseEvent): void {
    event.stopPropagation();
    this.officeDropdownOpen = !this.officeDropdownOpen;
  }

  onSwitchOffice(officeId: number, event: MouseEvent): void {
    event.stopPropagation();
    this.officeDropdownOpen = false;
    if (this.switchingOffice || !officeId || officeId === this.activeOffice?.id) return;
    this.switchingOffice = true;
    this.authService.switchOffice(officeId).subscribe({
      next: res => {
        const office = res.data?.active_office ?? this.offices.find(o => o.id === officeId);
        // Persistir la sucursal activa y recargar para aplicar el filtrado en todas las vistas.
        if (this.user) {
          this.authStateService.setUser({ ...this.user, active_office: office });
        }
        window.location.reload();
      },
      error: () => {
        this.switchingOffice = false;
      }
    });
  }

  permissionCheck(item: MenuItem){
    // Si el item tiene permisos definidos, verificarlos
    if (item.permission) {
      return this.permissions.indexOf(item.permission) !== -1;
    }

    // Si no tiene permisos, mostrar para todos
    return true;
  }

}
